<template lang="pug">
.vacancy-card(@click="openVacancy" :class="{ 'hidden-card': vacancy.hidden }")
  .vacancy-title
    span {{ vacancy.title }}
  p.summary {{ vacancy.summary }}
  p.call-to-action Lees verder
  p.reaction-count(v-if="loggedIn" @click.prevent="toReactions") {{ reactionCount }}
  p.hidden(v-if="vacancy.hidden") Verborgen voor publiek
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('auth', ['loggedIn']),
    reactionCount() {
      const count =
        (this.vacancy.reactions &&
          this.vacancy.reactions.items &&
          this.vacancy.reactions.items.length) ||
        0
      return count === 1 ? '1 reactie' : `${count} reacties`
    },
  },
  methods: {
    openVacancy() {
      this.$router.push({ name: 'vacancydetails', params: { id: this.vacancy.id } })
    },
    toReactions() {
      console.log('todo: view reactions')
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@/assets/_variables.styl'

.vacancy-card
  cursor pointer
  transition all 0.1s ease
  padding 2rem 1rem
  background-color vacancies-card-background-color
  border-radius 5px
  border 1px solid transparent
  box-shadow 0 2px 2px 0 rgba(127, 127, 127, 127)

  &.hidden-card
    opacity 0.7

  &:hover
    // background-color transparent
    border 1px solid black // vacancies-card-background-color
    opacity 1

  .vacancy-title
    font-size 2rem
    font-weight bold
    margin-bottom 1rem
    color vacancies-card-title-color

  p
    font-size 1.6rem

  .summary
    margin-bottom 1rem

  .call-to-action
    text-align right
    bottom 0
    text-decoration underline

  .hidden
    font-style italic
    color #557
</style>
